export const skillsCardAnime ={
    from:{
        scaleY: 0, opacity: 0,
    },to:{
        scaleY: 1, opacity: 1,
        transition: {
            delay: 0.3,
        }
    }
}